import React, { useEffect, useState } from "react";
import { Progress } from "antd";

const DpatCircleProgressLoader = ({ done = false, label = "Loading scores" }) => {
  const [percent, setPercent] = useState(8);

  useEffect(() => {
    if (done) {
      setPercent(100);
      return undefined;
    }
    setPercent((current) => (current >= 100 ? 12 : Math.max(current, 8)));
    const timer = window.setInterval(() => {
      setPercent((current) => {
        if (current >= 92) return current;
        const step = current < 40 ? 4 : current < 70 ? 3 : 1;
        return Math.min(92, current + step);
      });
    }, 220);
    return () => window.clearInterval(timer);
  }, [done]);

  return (
    <div className="dpat-circle-progress" role="status" aria-live="polite">
      <Progress
        type="circle"
        percent={percent}
        width={132}
        strokeWidth={7}
        strokeColor="#1677ff"
        trailColor="#e8f3ff"
        format={(value) => `${value}%`}
      />
      {label ? <p className="dpat-circle-progress__label">{label}</p> : null}
    </div>
  );
};

export default DpatCircleProgressLoader;
